module.exports = __webpack_public_path__ + "poppins-medium_0-webfont.4614fd045a20080fd501.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/poppins-medium_0-webfont.woff2
// module id = ../../../../../src/assets/fonts/poppins-medium_0-webfont.woff2
// module chunks = 2